import React from 'react';
import {Tab, Tabs, TabProps} from '@material-ui/core';
import './TicketActivityTab.scss';

export interface ITicketActivityTabProps {
  tabs: Array<{label: string} & TabProps>;
  value: any;
  onChange: (event: React.ChangeEvent<Record<string, any>>, value: any) => void;
}

const TicketActivityTab = (props: ITicketActivityTabProps): JSX.Element => {
  const {tabs, onChange, value} = props;
  return (
    <Tabs
      value={value}
      onChange={onChange}
      classes={{root: 'tabs-root', indicator: 'tabs-indicator'}}
      className="ticketing-system-activity-tab">
      {tabs.map(({value: tabValue, label: tabLabel, ...rest}) => (
        <Tab
          classes={{root: 'tab-root', selected: 'tab-selected'}}
          key={tabValue}
          value={tabValue}
          label={tabLabel}
          {...rest}
        />
      ))}
    </Tabs>
  );
};

export default TicketActivityTab;
